module.exports = __webpack_public_path__ + "img/Frame 35.e1559ad0.png";